export default {
  bannerInternalTrainingData: {
    es: [
      {
        name: 'internalTraining',
        imageBanner: '',
        imageDesktopXL: '/assets/images/internal-training/banner-internal-training-desktop-xl.svg',
        imageDesktop: '/assets/images/internal-training/banner-internal-training-desktop.svg',
        imageMobile: '/assets/images/internal-training/banner-internal-training-mobile.svg',
        imageTablet: '/assets/images/internal-training/banner-internal-training-desktop.svg',
        altImage: 'Somos Kairós DS',
        text1: '',
        text2: 'Pensar, hacer,',
        text3: 'Crecer',
        buttonText: '',
        buttonLink: '',
        buttonTarget: '',
      },
    ],
    en: [
      {
        name: 'internalTraining',
        imageBanner: '',
        imageDesktopXL: '/assets/images/internal-training/banner-internal-training-desktop-xl.svg',
        imageDesktop: '/assets/images/internal-training/banner-internal-training-desktop.svg',
        imageMobile: '/assets/images/internal-training/banner-internal-training-mobile.svg',
        imageTablet: '/assets/images/internal-training/banner-internal-training-desktop.svg',
        altImage: 'Somos Kairós DS',
        text1: '',
        text2: 'Think, build,',
        text3: 'Grow',
        buttonText: '',
        buttonLink: '',
        buttonTarget: '',
      },
    ],
  },
};
